



























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import ProfileAvatar from '@/components/Profile/ProfileAvatar.vue';
import {UserModel} from '@/models/user.model';
import {AuthApi} from '@/api/auth.api';
import {take} from 'rxjs/operators';

@Component({
  components: {
    ProfileAvatar,
  },
})
export default class MembershipCard extends Vue {
  @Prop({required: true})
  user!: UserModel;
  loading = false;

  get fullname() {
    return `${this.user.first_name} ${this.user.last_name}`;
  }

  get alreadyConfirmed(): boolean {
    return !!this.user?.confirmed_at;
  }

  get userCountryResidence() {
    return this.user.contestant && (
      this.user.contestant.country_residence && (
        this.user.contestant.country_residence.name
      )
    );
  }

  get memberTime() {
    return this.user.created_at && (
      new Date(this.user.created_at).getFullYear()
    );
  }

  requestNewConfirmationEmail(): void {
    if (!this.loading) {
      this.loading = true;
      new AuthApi().resendEmailVerify().pipe(take(1)).subscribe(
        (res) => this.loading = false,
        (e) => this.loading = false
      )
    }
  }

  formatPartnershipID(value: number): string {
    return `000000${value}`.substr(`${value}`.length);
  }
}
